export default {"src":"/_next/static/media/check-solid.4dc93e69.svg","height":512,"width":448,"blurWidth":0,"blurHeight":0};